import {
  GLOBAL_SEARCH,
  LATEST_GLOBAL_SEARCHES,
  SELECTED_GLOBAL_SEARCH
} from '../actions';

export const globalSearchReducer = (state = {}, action) => {
  if (action.type == GLOBAL_SEARCH) return action.payload;
  return state;
};

export const latestGlobalSearchReducer = (state = [], action) => {
  if (action.type == LATEST_GLOBAL_SEARCHES) return action.payload;
  return state;
};

export const selectedGlobalSearchReducer = (state = {}, action) => {
  if (action.type == SELECTED_GLOBAL_SEARCH) return action.payload;
  return state;
};
